import React, { useState } from "react";
import UserNav from "../Shared/UserNav";
import { StartProps } from "./MainApp";
import { Box, FormLabel, ListItem, ListItemIcon, ListItemText, MenuItem, MenuList, Paper } from "@mui/material";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import InsightsIcon from '@mui/icons-material/Insights';
import BallotIcon from '@mui/icons-material/Ballot';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { NavLink, useLocation } from "react-router-dom";
import CampaignIcon from '@mui/icons-material/Campaign';
import { FeedbackDialog } from "../Shared/Feedback";
import Api from "../../network/Api";

export type SidebarMenuProps = {
  open: boolean;
  size?: "small"|"medium";
  toggleAfterClick?: boolean;
  onToggle: () => void;
}

const Sidebar = (props: StartProps & SidebarMenuProps) => {

  const { pathname } = useLocation();
  const [showsFeedbackDialog, showFeedbackDialog] = useState<boolean>(false);
  const [feedback, setFeedback] = useState<string>();

  const sendFeedback = () => {
    Api.post(`/feedbacks`, { comment: feedback });
    showFeedbackDialog(false);
  }

  const onClick = () => {
    if (props.toggleAfterClick) {
      props.onToggle();
    }
  }

  return <>
    <UserNav {...props} />

    <MenuList sx={{display: "flex", flexDirection: "column", flex: 1}}>
      <Item icon={<InsightsIcon />} text={props.open ? "Dashboard" : ""} to="/dashboard" isActive={pathname === "/dashboard"} onClick={onClick} />
      <Item icon={<AutoFixHighIcon />} text={props.open ? "Lesson capturer" : ""} to="/lessons/new" isActive={pathname === "/lessons/new"} onClick={onClick} />
      <Item icon={<BallotIcon />} text={props.open ? "Knowledge base" : ""} to="/lessons" isActive={pathname === "/lessons"} onClick={onClick} />
      <Item icon={<TipsAndUpdatesIcon />} text={props.open ? "Solution manager" : ""} to="/solutions" isActive={pathname === "/solutions"} onClick={onClick} />

      <MenuItem sx={{mt: "auto", px: 4, [`:hover`]: { backgroundColor: "transparent !important" }}} disableRipple onClick={() => showFeedbackDialog(true)}>
        <ListItemIcon sx={{minWidth: '0 !important'}}><CampaignIcon fontSize="small" /></ListItemIcon>
        {props.open && <ListItemText sx={{ml: 0.5}}><FormLabel><small>Report a bug</small></FormLabel></ListItemText> }
      </MenuItem>

      { showsFeedbackDialog && <FeedbackDialog value={feedback} onChange={setFeedback} onClose={() => showFeedbackDialog(false)} onSubmit={sendFeedback} /> }
    </MenuList>
  </>
}

const Item = (props: { icon: JSX.Element, text: string, isActive?: boolean, to?: string, onClick?: () => void }) => {

  return <ListItem sx={{py: 0.5}}>
    <Paper elevation={0} className={props.isActive ? "bg-grey" : ""} sx={{background: "transparent", flex: 1, p: 0.5}}>
      <MenuItem component={props.to ? NavLink : Box} 
                to={props.to} 
                onClick={props.onClick}
                disableRipple 
                sx={{[`:hover`]: { backgroundColor: "transparent !important" }}}>
        <ListItemIcon sx={{minWidth: '0 !important'}}><span className={props.isActive ? "text-primary" : "text-secondary"} style={{lineHeight: 0}}>{props.icon}</span></ListItemIcon>
        <ListItemText sx={{ml: 1.5}}><span className="text-primary" style={{fontFamily: "var(--header-font)"}}>{props.text}</span></ListItemText>
      </MenuItem>
    </Paper>
  </ListItem>
}

export default Sidebar;